/**
 * Accessible tabs (WAI-ARIA Tabs pattern).
 *
 * Any container with `data-tabs` holding [role="tablist"] > [role="tab"] and
 * sibling [role="tabpanel"] elements. Each tab's aria-controls points at its
 * panel id. Arrow keys move between tabs; the active panel is shown, others
 * get `hidden`.
 *
 * @see https://www.w3.org/WAI/ARIA/apg/patterns/tabs/
 */
( function () {
	'use strict';

	function setup( root ) {
		var tabs = Array.prototype.slice.call( root.querySelectorAll( '[role="tab"]' ) );
		if ( ! tabs.length ) {
			return;
		}

		function activate( tab, focus ) {
			tabs.forEach( function ( t ) {
				var selected = t === tab;
				t.setAttribute( 'aria-selected', selected ? 'true' : 'false' );
				t.tabIndex = selected ? 0 : -1;
				var panel = document.getElementById( t.getAttribute( 'aria-controls' ) );
				if ( panel ) {
					panel.hidden = ! selected;
				}
			} );
			if ( focus ) {
				tab.focus();
			}
		}

		tabs.forEach( function ( tab, i ) {
			tab.addEventListener( 'click', function () {
				activate( tab );
			} );
			tab.addEventListener( 'keydown', function ( e ) {
				var idx = null;
				if ( e.key === 'ArrowRight' || e.key === 'ArrowDown' ) {
					idx = ( i + 1 ) % tabs.length;
				} else if ( e.key === 'ArrowLeft' || e.key === 'ArrowUp' ) {
					idx = ( i - 1 + tabs.length ) % tabs.length;
				} else if ( e.key === 'Home' ) {
					idx = 0;
				} else if ( e.key === 'End' ) {
					idx = tabs.length - 1;
				}
				if ( idx !== null ) {
					e.preventDefault();
					activate( tabs[ idx ], true );
				}
			} );
		} );
	}

	function init() {
		var roots = document.querySelectorAll( '[data-tabs]' );
		for ( var i = 0; i < roots.length; i++ ) {
			setup( roots[ i ] );
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
